module.exports = __webpack_public_path__ + "static/media/buy_report_user_6.3619fb62.png";